import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import { Box, Text } from 'grommet';
import styled from 'styled-components';
import * as WorkspaceDucks from 'granite-admin/accounts/ducks/workspace';
import useQuery from 'granite-admin/utils/useQuery';
import { Close, Add } from 'grommet-icons';
import { getGrandEmitter } from 'granite-admin/utils/grandEmitter';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useToast } from 'granite-admin/core/components/Toast';
String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};
const hasNumber = str => {
  return /\d/.test(str);
};
const TextTruncate = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;
const Tab = styled(Box)`
  margin-top: 3px;
  padding: 0 4px 0 12px;
  position: relative;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  margin-left: ${props => props.selected ? '-1px' : 'unset'};
  border-top: ${props => props.selected ? '1px solid brand' : '1px solid #fff'};
  border-bottom: 1px solid ${props => props.theme.global.colors.brand};
  &:focus {
    box-shadow: none;
  }
  &:after {
    content: '';
    height: 70%;
    width: ${props => props.selected ? 'unset' : '1px'};
    position: absolute;
    right: 0;
    top: 4px;
    background: #999;
  }
  &:before {
    content: '';
    height: 70%;
    width: 'unset';
    position: absolute;
    left: 0;
    top: 4px;
    background: #999;
  }
`;
const WorkspaceTabs = ({
  workspaceTabs,
  selectedWorkspace,
  dispatch,
  history,
  maxTabs,
  businessAdmin,
  selectedOrganisation,
  eventEmitter,
  // breadcrumbPath,
  addTabBtn,
  tabName
}) => {
  const {
    pathname,
    query,
    createQueryString
  } = useQuery();
  const params = useParams();
  let queryString = createQueryString(query);
  const url = pathname + '?' + queryString;
  const tabParent = useRef(null);
  const {
    errorToast
  } = useToast();

  // console.log('breadcrumbPath', breadcrumbPath);
  // var lastBreadCrumb = breadcrumbPath[breadcrumbPath.length - 2];
  // console.log('lastBreadCrumb', lastBreadCrumb);

  let tabTitle = pathname?.split('/')[1]?.capitalize();

  // let tabTitle = lastBreadCrumb?.label
  tabTitle = tabName ? tabName : 'id' in params ? hasNumber(params.id) ? `${tabTitle} - ${params.id}` : tabTitle : tabTitle;
  const [updateKey, setUpdateKey] = useState(1);
  const grandEmitter = useMemo(() => getGrandEmitter(), []);
  const setWorkspace = useCallback(arr => {
    dispatch({
      type: 'accounts/workspace/UPDATE_WORKSPACE_TABS',
      data: arr
    });
  }, [dispatch]);
  const selectWorkspace = useCallback(id => {
    dispatch({
      type: 'accounts/workspace/SELECT_WORKSPACE',
      data: id
    });
  }, [dispatch]);
  const openNewTab = useCallback(() => {
    let newTab = {
      id: workspaceTabs.length + 1,
      index: workspaceTabs.length,
      url: '/new-tab',
      tabTitle: 'New Tab'
    };
    setWorkspace([...workspaceTabs, newTab]);
    selectWorkspace(newTab.id);
    history.push(newTab.url);
  }, [history, selectWorkspace, setWorkspace, workspaceTabs]);
  const removeTab = useCallback((id, movetoTab) => {
    let updatedWorkspace = workspaceTabs.filter(item => {
      return item.id !== id;
    });
    for (let i of updatedWorkspace) {
      if (i.id > id) {
        i.id = i.id - 1;
      }
    }
    setWorkspace(updatedWorkspace);
    let lastTab = movetoTab || updatedWorkspace[updatedWorkspace.length - 1];
    selectWorkspace(lastTab.id);
    history.push(lastTab.url);
  }, [history, selectWorkspace, setWorkspace, workspaceTabs]);
  const addTab = useCallback(path => {
    if (workspaceTabs.length < maxTabs) {
      const {
        label,
        pathname,
        search
      } = path;
      let newTab = {
        id: workspaceTabs.length + 1,
        index: workspaceTabs.length,
        url: search ? pathname + search : pathname,
        tabTitle: label
      };
      setWorkspace([...workspaceTabs, newTab]);
      selectWorkspace(newTab.id);
      history.push({
        pathname: pathname,
        search: search
      });
    } else {
      errorToast('Max 8 workspace tabs can be opened. Please close any tab and try again.');
    }
  }, [eventEmitter, history, maxTabs, selectWorkspace, setWorkspace, workspaceTabs]);
  const changeTabLabel = useCallback(({
    id,
    label
  }) => {
    let tab = workspaceTabs.find(item => item.id === id);
    if (tab) {
      tab.tabTitle = label;
      setWorkspace([...workspaceTabs, tab]);
    }
  }, [setWorkspace, workspaceTabs]);
  useEffect(() => {
    let selectedWS = workspaceTabs.find(item => item.id === selectedWorkspace);
    if (selectedWS) {
      selectedWS.url = url;
      selectedWS.tabTitle = tabTitle;
      setWorkspace(workspaceTabs);
      const prevTab = workspaceTabs.filter(item => selectedWS.url === item.url && selectedWS.id !== item.id);
      if (prevTab.length) {
        removeTab(selectedWS.id, prevTab[0]);
      }
    }
  }, [removeTab, selectedWorkspace, setWorkspace, tabTitle, url, workspaceTabs]);
  useEffect(() => {
    setUpdateKey(prev => prev + 1);
  }, [workspaceTabs]);
  useEffect(() => {
    const subscription = grandEmitter.getObservable().subscribe(event => {
      switch (event.type) {
        case 'ADD_TAB':
          // console.log("ADD")
          addTab(event.data);
          break;
        case 'CHANGE_CURRENT_TAB_LABEL':
          // console.log("current");
          changeTabLabel(event.data);
          break;
        default:
          break;
      }
    });
    return () => subscription.unsubscribe();
  }, [addTab, changeTabLabel, grandEmitter, workspaceTabs]);

  // let tabParentWidth = tabParent?.current?.clientWidth;
  let widthUsed = 20;
  if (businessAdmin && selectedOrganisation?.pk) widthUsed = widthUsed + 75;
  if (addTabBtn === true && workspaceTabs.length < maxTabs) widthUsed = widthUsed + 35;
  widthUsed = widthUsed + workspaceTabs.length * 140;
  return /*#__PURE__*/React.createElement(Box, {
    width: "full",
    direction: "row",
    background: '#fff'
  }, /*#__PURE__*/React.createElement(Box, {
    gap: "none",
    direction: "row",
    key: updateKey,
    width: "100%",
    ref: tabParent
  }, /*#__PURE__*/React.createElement(Box, {
    width: {
      min: '8px',
      max: '8px'
    },
    border: {
      color: 'brand',
      size: '0.5px',
      side: 'bottom'
    }
  }), (workspaceTabs?.length > 1 || addTabBtn) && workspaceTabs.map((item, index) => {
    return /*#__PURE__*/React.createElement(Tab, {
      selected: selectedWorkspace === item.id,
      single: workspaceTabs.length === 1,
      first: index === 0,
      last: workspaceTabs.length === maxTabs,
      background: selectedWorkspace === item.id ? 'brand' : '#fff',
      pad: {
        left: 'xsmall',
        right: workspaceTabs.length === 1 ? 'small' : 'none'
      },
      direction: "row",
      width: '170px',
      height: "30px",
      key: index,
      justify: "between",
      addTabBtn: addTabBtn,
      onClick: () => {
        selectWorkspace(item.id);
        history.push(item.url);
      }
    }, /*#__PURE__*/React.createElement(Box, {
      alignSelf: "center"
    }, /*#__PURE__*/React.createElement(TextTruncate, {
      weight: 'normal',
      title: item.tabTitle,
      alignSelf: "start",
      size: "medium",
      truncate: true,
      color: selectedWorkspace === item.id ? '#fff' : '#000'
    }, item.tabTitle)), workspaceTabs.length !== 1 && /*#__PURE__*/React.createElement(Box, {
      margin: {
        horizontal: 'small'
      },
      alignSelf: "center",
      onClick: e => {
        e.stopPropagation();
        removeTab(item.id);
      }
    }, /*#__PURE__*/React.createElement(Close, {
      color: selectedWorkspace === item.id ? '#fff' : '#000',
      size: "10px"
    })));
  }), addTabBtn === true && workspaceTabs.length < maxTabs && /*#__PURE__*/React.createElement(Box, {
    background: "#fff",
    pad: {
      horizontal: '10px'
    },
    border: {
      color: '#fff',
      size: '0.5px',
      side: 'all'
    },
    width: {
      max: '35px',
      min: '35px'
    },
    height: "35px",
    direction: "row",
    onClick: () => {
      if (workspaceTabs.length < maxTabs) {
        openNewTab();
      }
    }
  }, /*#__PURE__*/React.createElement(Box, {
    alignSelf: "center"
  }, /*#__PURE__*/React.createElement(Add, {
    color: "#222D39",
    size: "14px"
  }))), /*#__PURE__*/React.createElement(Box, {
    width: `100%`,
    border: {
      color: 'brand',
      size: '0.5px',
      side: 'bottom'
    }
  })));
};
const mapStateToProps = state => ({
  workspaceTabs: WorkspaceDucks.tabs(state),
  selectedWorkspace: WorkspaceDucks.selected(state)
});
const mapDispatchToProps = dispatch => ({
  dispatch: dispatch
});
WorkspaceTabs.propTypes = {
  workspaceTabs: PropTypes.object,
  selectedWorkspace: PropTypes.number,
  dispatch: PropTypes.func,
  history: PropTypes.object,
  maxTabs: PropTypes.number,
  businessAdmin: PropTypes.bool,
  selectedOrganisation: PropTypes.object,
  eventEmitter: PropTypes.object,
  // breadcrumbPath: PropTypes.array,
  addTabBtn: PropTypes.bool,
  tabName: PropTypes.string
};
export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceTabs);